const Colors = {
  blue: '#0022FC',
  orange: '#FF5E00',
  black: '#000000',
  white: '#FFFFFF',
  grey: '#EBEBEB'
}

export default Colors
